import type { ReactNode } from "react";
import type { SourcingEventDto } from "../../../autogen/bff-api";
import { allowsPartIIDialogue } from "../rounds/partIIDialogue";
import { useTranslation } from "react-i18next";
import { NotReadyCard } from "../NotReadyCard";
import { unscoredRoundTenders } from "../evaluation/evaluationCompleteness";
import { useRoundSelection } from "../rounds/RoundSelectionContext";
import { useAwardSelection } from "./AwardSelectionContext";

export const RoundTendersScoredGate = ({ event, children }: { event: SourcingEventDto; children: ReactNode }) => {
  const { t } = useTranslation();
  const { rounds } = useRoundSelection();
  const { evaluation } = useAwardSelection();
  const unscored = unscoredRoundTenders(evaluation, rounds);
  if (unscored.length === 0) return <>{children}</>;
  return (
    <NotReadyCard
      title={String(t("The award is not ready yet"))}
      description={String(
        allowsPartIIDialogue(event)
          ? t("Score {{suppliers}} before you award. Tenderers that delivered nothing in the round stay in on their latest tender.", {
              suppliers: unscored.map((bid) => bid.supplierName).join(", "),
            })
          : t("Score {{suppliers}} in the latest round before you award. Only the tenders from the latest round count.", {
              suppliers: unscored.map((bid) => bid.supplierName).join(", "),
            }),
      )}
    />
  );
};
